import { render } from "./CardToolbar.vue?vue&type=template&id=05a2bd5b&scoped=true"
import script from "./CardToolbar.vue?vue&type=script&lang=js"
export * from "./CardToolbar.vue?vue&type=script&lang=js"

import "./CardToolbar.vue?vue&type=style&index=0&id=05a2bd5b&lang=scss&scoped=true"

import exportComponent from "/builds/playmob1/songreach/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05a2bd5b"]])

export default __exports__